import React, { useState, useEffect } from 'react';
import {Divider, Grid } from '@material-ui/core';
import { useStyles } from './style';
import Form from 'components/Form/FormTwoColumns';
import {connect } from "react-redux";
import mapStateToProps from './mapStateToProps';
import mapDispatchToProps from './mapDispatchToProps';
import ResponseElement from 'components/ResponseElement';
// import BotonPersonalizado from 'components/BotonNormal'

function Searcher({validarIdentidadDelCiudadano, SOLICITUD_EMPADRONAMIENTO_EXTRANJERO_SET_STEP, CLEAR_DATOS_GENERALES_DEL_CIUDADANO, datosSolicitudExtranjero, citaEnProceso}) {
  const classes = useStyles();

  const [responseData, setResponseData] = useState({
    errorType: "error",
    messageType: "",
    openResponse: false,
  });

  const keyPress = (event) => {
    CLEAR_DATOS_GENERALES_DEL_CIUDADANO();
    if (event.key === "Enter") {
      if (!/^[0-9]{13}$/.test(event.target.value))
        changeDataResponse(
          "error",
          "CUI demasiado corto/largo o incluye letras",
          true
        );
      else validarIdentidadDelCiudadano(event.target.value);
    }
  };

  // elements to build the form
  const [elements, setElements] = React.useState({
    cui: {
      idelement: "cui",
      value: datosSolicitudExtranjero?.dpi || "",
      label: "Ingrese CUI del DPI",
      pattern: "^[0-9]{13}$",
      validators: ["required"],
      errorMessages: ["Ingrese un CUI válido, Numérico de 13 digitos"],
      isError: false,
      elementType: "input",
      disabled: false,
      autofocus: true,
      keyPress: keyPress,
    },
  });

  // to change data response
  const changeDataResponse = (errorType, messageType, openResponse = false) => {
    setResponseData({ errorType, messageType, openResponse });
  };

  const handCloseResponseData = () => {
    setResponseData({
      errorType: "error",
      messageType: "",
      openResponse: false,
    });
  };

  const setCuiFromCitaAndSearch = () => {
    let newElements = Object.assign({}, elements);
    newElements.cui.value = citaEnProceso.cuiCiudadano;
    newElements.cui.disabled = true;
    newElements.cui.isError = false;
    setElements({ ...newElements });
    CLEAR_DATOS_GENERALES_DEL_CIUDADANO();
    validarIdentidadDelCiudadano(citaEnProceso.cuiCiudadano);
  };

  // Diego // DONE.
  // Tocar el elements y setearles valores default y regular.
  // Mandar a llamar "validarIdentidadDelCiudadano()".

  useEffect(() => {
    // console.log("citaEnProceso en searcher:", citaEnProceso);
    if (citaEnProceso.idCita !== "" && citaEnProceso.cuiCiudadano !== "") {
      setCuiFromCitaAndSearch();
    }
  }, []);

  const { errorType, messageType, openResponse } = responseData;
  const nextStep = () => {
    SOLICITUD_EMPADRONAMIENTO_EXTRANJERO_SET_STEP(1);
  };
  return (
    <Grid container className={classes.root}>
      <Grid item xs={12}>
        <div className={classes.centerTitle}>
          <Divider /> <strong>BUSCAR CIUDADANO POR CUI DEL DPI</strong>{" "}
          <Divider />
        </div>
      </Grid>
      <Grid item xs={12}>
        <ResponseElement
          type={errorType}
          content={messageType}
          open={openResponse}
          handClose={handCloseResponseData}
        />
        <Grid className={classes.cardContent}>
          <Form elements={elements} />
        </Grid>
      </Grid>
      {/* <Grid item xs={12}>
                <BotonPersonalizado title={"Siguiente"} botonSiguiente={true} function={nextStep}/>
            </Grid> */}
    </Grid>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Searcher);